/**
 * DEPRECATED - Helper for building a resource list component
 *
 * Call directly and pass an object like a normal component.
 * `templateUrl` can be a string: it will be converted to a function by this helper.
 *
 * @deprecated
 * @example
 * import { resourceListBindings } from 'tmr/components/resourceList/resourceListHelper'
 * import templateUrl from './myResource.html'
 * export const component = ['tmrAdminMyResource', resourceListComponent({
 *   templateUrl
 * })]
 */
function resourceListComponent(defaults) {
  console.warn(
    'resourceListComponent is deprecated: use resourceListBindings instead'
  )
  defaults.bindings = defaults.bindings ?? {}
  resourceListBindings(defaults.bindings)
  return defaults
}

/**
 * Helper for adding required bindings to a component that uses the {@link tmrResourceList} component
 *
 * @example
 * export const component = ['tmrAdminMyResourceList', {
 *   bindings: resourceListBindings({
 *     someAdditionalBinding: '<'
 *   })
 * }];
 *
 * @prop {object=} bindings Additional component bindings
 */
function resourceListBindings(bindings = {}) {
  return Object.assign(bindings, {
    resources: '<',
    resourcesCount: '<',
    currentPage: '<',
    pageSize: '<',
  })
}

export { resourceListComponent, resourceListBindings }
